import { faArrowDownLeftAndArrowUpRightToCenter } from '@fortawesome/pro-regular-svg-icons'
import { Button, Modal } from '@karnov/kui-react'

import { useTranslation } from 'services/i18n'

import type { PropsWithChildren } from 'react'

type Props = {
  isTableOpen: boolean
  onTablePreviewToggle: VoidFunction
}

export const TableModal = ({
  isTableOpen,
  onTablePreviewToggle,
  children,
}: PropsWithChildren<Props>) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'conversation.table_view',
  })

  return (
    <Modal
      title={t('modal_title')}
      name="table-preview-content"
      isFullWidth
      isOpen={isTableOpen}
      onClose={onTablePreviewToggle}
      isCompact
    >
      <div className="markdown-container">
        {children}
        <div className="flex flex-col items-end">
          <Button
            icon={faArrowDownLeftAndArrowUpRightToCenter}
            onClick={onTablePreviewToggle}
            isSmall
          >
            {t('close_button')}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
